import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Board } from '@components/board/Board';
import { GameStatus } from './GameStatus';
import { Timer } from './Timer';
import { MoveHistory } from './MoveHistory';
import { GameControls } from './GameControls';
import { ChatContainer } from '@components/chat/ChatContainer';
import { RoomInfo } from '@components/room/RoomInfo';
import { VoiceChat } from '@components/voice/VoiceChat';
import { useGameStore, useRoomStore } from '@store/index';
import { useSocket } from '@hooks/useSocket';
import styles from './GameContainer.module.css';

export const GameContainer: React.FC = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const gameState = useGameStore((state) => state.gameState);
  const playerColor = useRoomStore((state) => state.playerColor);
  const roomCode = useRoomStore((state) => state.roomCode);
  const { makeMove } = useSocket();
  
  useEffect(() => {
    // Redirect if no room code
    if (!roomCode || roomCode !== code) {
      navigate('/');
    }
  }, [roomCode, code, navigate]);
  
  const handleMove = (from: any, to: any, promotion?: any) => {
    makeMove({ from, to, promotion });
  };
  
  if (!gameState || !playerColor) {
    return (
      <div className={styles.loading}>
        <p>Waiting for opponent...</p>
      </div>
    );
  }
  
  // Ensure board squares is a Map
  if (gameState.board && !(gameState.board.squares instanceof Map)) {
    console.warn('Converting board squares to Map');
    gameState.board.squares = new Map(Object.entries(gameState.board.squares || {}));
  }
  
  return (
    <div className={styles.container}>
      <div className={styles.sidebar}>
        <RoomInfo />
        <GameStatus />
        <Timer color="white" />
        <Timer color="black" />
        <GameControls />
      </div>
      
      <div className={styles.board}>
        <Board
          gameState={gameState}
          orientation={playerColor}
          onMove={handleMove}
          disabled={gameState.gameStatus !== 'active'}
        />
      </div>
      
      <div className={styles.rightPanel}>
        <MoveHistory />
        <VoiceChat />
        <ChatContainer />
      </div>
    </div>
  );
};